import { Outlet } from "react-router-dom";
import { TopNav } from "./TopNav";
import { BottomNav } from "./BottomNav";
import { MiniPlayer } from "@/components/player/MiniPlayer";
import { usePlayer } from "@/context/PlayerContext";

export const AppShell = () => {
  const { track } = usePlayer();
  return (
    <div className="min-h-screen bg-nw-bg text-slate-100 grain">
      <TopNav />
      <main className={`relative mx-auto max-w-6xl px-4 sm:px-6 pt-20 ${track ? "pb-48 md:pb-32" : "pb-28 md:pb-16"}`}>
        <Outlet />
      </main>
      <MiniPlayer />
      <BottomNav />
    </div>
  );
};
